export default "__VITE_ASSET__2359c4ae__"